module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/start/app.component.css
// module id = ./src/app/components/start/app.component.css
// module chunks = main